<template>
  <main
    class="grid min-h-full place-items-center overflow-y-auto bg-[linear-gradient(135deg,#062b63,#0d63c7_48%,#f5f9fd_48%)] p-4"
  >
    <section
      class="grid w-full max-w-5xl overflow-hidden rounded-[28px] bg-white shadow-2xl md:grid-cols-[1.05fr_0.95fr]"
    >
      <div
        class="relative hidden min-h-[620px] bg-brand-900 p-8 text-white md:block"
      >
        <div
          class="absolute inset-0 bg-[radial-gradient(circle_at_24%_20%,rgba(255,255,255,0.22),transparent_28%),linear-gradient(150deg,rgba(31,122,224,0.55),transparent_48%)]"
        ></div>
        <div class="relative z-10 flex h-full flex-col justify-between">
          <div class="flex items-center gap-3">
<!--            <img-->
<!--              src="../assets/logoMBF.png"-->
<!--              alt="MBF"-->
<!--              class="h-14 w-14 rounded-2xl bg-white object-contain p-2"-->
<!--            />-->
            <div>
<!--              <p-->
<!--                class="text-sm font-semibold uppercase tracking-[0.24em] text-blue-100"-->
<!--              >-->
<!--                Mobifone-->
<!--              </p>-->
              <p class="text-2xl font-black">Quản lý tài sản</p>
            </div>
          </div>
          <div>
            <p class="mb-4 text-lg font-semibold text-blue-100">
              Dashboard vận hành
            </p>
            <h2 class="max-w-md text-4xl font-black leading-tight">
              Theo dõi thiết bị, bàn giao và xuất báo cáo.
            </h2>
          </div>
          <div class="grid grid-cols-3 gap-3 text-center">
            <div class="rounded-2xl bg-white/10 p-4 backdrop-blur">
              <p class="text-2xl font-black">01</p>
              <p class="text-xs text-blue-100">Tài sản</p>
            </div>
            <div class="rounded-2xl bg-white/10 p-4 backdrop-blur">
              <p class="text-2xl font-black">02</p>
              <p class="text-xs text-blue-100">Bàn giao</p>
            </div>
            <div class="rounded-2xl bg-white/10 p-4 backdrop-blur">
              <p class="text-2xl font-black">03</p>
              <p class="text-xs text-blue-100">Báo cáo</p>
            </div>
          </div>
        </div>
      </div>

      <form class="p-6 sm:p-10" @submit.prevent="doLogin">
        <div class="mb-8 flex items-center gap-3 md:hidden">
          <img
            src="../assets/logoMBF.png"
            alt="MBF"
            class="h-12 w-12 rounded-2xl object-contain"
          />
          <div>
            <p
              class="text-xs font-semibold uppercase tracking-[0.2em] text-brand-600"
            >
              Mobifone
            </p>
            <p class="text-xl font-black text-ink">Quản lý tài sản</p>
          </div>
        </div>

        <p
          class="text-sm font-semibold uppercase tracking-[0.2em] text-brand-600"
        >
          Đăng nhập
        </p>
        <p class="mt-2 text-2xl font-bold text-ink">Chào mừng trở lại</p>
        <p class="mt-2 text-sm text-slate-500">
          Nhập thông tin tài khoản để tiếp tục vào dashboard.
        </p>

        <div class="mt-20 space-y-4">
          <div>
            <label class="label">Tên đăng nhập</label>
            <UiInput
              v-model="userName"
              class="h-12"
              autocomplete="username"
              placeholder="Nhập tên đăng nhập"
            />
          </div>
          <div>
            <label class="label">Mật khẩu</label>
            <UiInput
              v-model="password"
              class="h-12"
              type="password"
              autocomplete="current-password"
              placeholder="Nhập mật khẩu"
            />
          </div>
          <p
            v-if="errorMessage"
            class="rounded-xl bg-rose-50 px-3 py-2 text-sm font-medium text-rose-700"
          >
            {{ errorMessage }}
          </p>
          <UiButton
            type="submit"
            icon="login"
            variant="primary"
            size="lg"
            block
            :disabled="!valid"
            :loading="loading"
            loading-text="Đang đăng nhập..."
          >
            {{ loading ? "Đang đăng nhập..." : "Đăng nhập" }}
          </UiButton>
        </div>
      </form>
    </section>
  </main>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import AuthRepository from "../services/AuthRepository";
import QLTSRepository from "@/services/QLTSRepository";
import { Login } from "../models/login";

export default {
  setup() {
    const router = useRouter();
    const store = useStore();
    const userName = ref("");
    const password = ref("");
    const loading = ref(false);
    const errorMessage = ref("");
    const valid = computed(() => Boolean(userName.value && password.value));

    const doLogin = () => {
      if (!valid.value || loading.value) return;
      const login = {
        username: userName.value,
        password: password.value,
      } as Login;

      loading.value = true;
      errorMessage.value = "";
      // Không dùng lại quyền được Vuex persist từ phiên đăng nhập trước.
      store.dispatch("clearPermission");
      store.dispatch("clearSessionExpired");
      AuthRepository.auth(login)
        .then((response) => {
          store.dispatch("setToken", response.data.token);
          store.dispatch("setPermission", response.data.permission);
          store.dispatch("setFullName", response.data.fullname);
          store.dispatch("setSessionConfig", {
            idleTimeoutSeconds: response.data.idleTimeoutSeconds,
            refreshIntervalSeconds: response.data.refreshIntervalSeconds,
          });
          return QLTSRepository.getUserInfo().then((info) => {
            store.dispatch("setFullName", info.data.fullName || response.data.fullname);
            store.dispatch("setTeam", info.data.team);
          });
        })
        .then(() => router.replace({ name: "home" }))
        .catch((err) => {
          errorMessage.value =
            (err && err.response && err.response.data) ||
            "Không thể đăng nhập. Vui lòng thử lại.";
        })
        .finally(() => {
          password.value = "";
          loading.value = false;
        });
    };

    return { userName, password, valid, doLogin, loading, errorMessage };
  },
};
</script>
